import Spinner from 'components/shared/app/Spinner';
import Config from 'lib/Config';
import { ValidationUtils } from 'lib/utils/Validation';
import Button from 'components/shared/app/Button';
import Logo from 'components/shared/app/Logo';
import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';
import './style.scss';

export default ForgotPassword = (props) => {
    const inputEmail = React.createRef();

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submit = () => {
        if (inputEmail.current) {
            const email = inputEmail.current.value;

            if (!email) {
                return setError('Please enter your email address');
            }

            if (!ValidationUtils.isEmail(email)) {
                return setError('Please enter a valid email address');
            }

            setLoading(true);
            props.auth.forgotPassword(email)
                .then(r => {
                    setSubmitted(true);
                })
                .catch(e => {
                    setError(e.error || 'An error occurred.');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const onEnter = (e) => {
        if (e.keyCode == 13) {
            submit();
        }
    };

    return (
        <div className="forgot-password center flex-col-center-both col-single pad-default">
            <Helmet>
                <title>{Config.SITE_TITLE_PREFIX} - Forgot Password</title>
            </Helmet>
            <div className="logo">
                <Logo symbol />
            </div>
            <div className="forgot-password-content">
                {submitted ? (
                    <div className="success">
                        <p>Please check your email for password reset instructions!</p>
                        <div className="button-row pad md ns">
                            <Link className="link" to="/login">
                                <Button
                                    round
                                    simple
                                    bold
                                    filled
                                    center
                                    color="white"
                                    icon={<img src={arrowIcon} />}
                                    iconPosition="right"
                                    textPosition="center">
                                    Return to Sign In
                                </Button>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <form className="forgot-password-form">
                        <div className="input-row pad lg ns">
                            <input
                                type="email"
                                autoComplete="email"
                                placeholder="Enter your email"
                                ref={inputEmail}
                                className="input simple"
                                onKeyUp={onEnter}
                            />
                        </div>
                        <div className="button-row pad md ns">
                            <Button
                                round
                                simple
                                bold
                                filled
                                center
                                color="white"
                                icon={loading ? <Spinner size="small fit" className="icon" color="blue" /> : <img src={arrowIcon} />}
                                iconPosition="right"
                                textPosition="center"
                                onClick={e => submit()}>
                                Reset My Password
                            </Button>
                        </div>
                        <div className="button-row pad md ns">
                            <Link className="link" to="/login">
                                Return to sign In
                            </Link>
                        </div>
                        {error && <div className="error pad sm">{error}</div>}
                    </form>
                )}
            </div>
        </div>
    );
};
